import React, { useState, useEffect } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import supabase from '../supabase';

export default function Golf() {
  const [rounds, setRounds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchRounds() {
      const { data, error } = await supabase
        .from('golf_rounds')
        .select('*')
        .order('date', { ascending: false })
        .limit(100);
      if (error) { setError(error.message); setLoading(false); return; }
      setRounds(data || []);
      setLoading(false);
    }
    fetchRounds();
  }, []);

  if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

  const cols = rounds.length > 0
    ? Object.keys(rounds[0]).filter(k => k !== 'id' && k !== 'user_id')
    : [];

  return (
    <div>
      <div className="page-header">
        <h1>Golf Rounds</h1>
        <p>{rounds.length} rounds played</p>
      </div>

      {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}

      {rounds.length === 0 ? (
        <div className="d-card"><p style={{ color: 'var(--text-muted)', margin: 0 }}>No rounds recorded.</p></div>
      ) : (
        <div className="d-card" style={{ overflowX: 'auto', padding: 0 }}>
          <table className="d-table">
            <thead>
              <tr>{cols.map(c => <th key={c}>{c.replace(/_/g, ' ')}</th>)}</tr>
            </thead>
            <tbody>
              {rounds.map(row => (
                <tr key={row.id}>
                  {cols.map(c => (
                    <td key={c}>{formatCell(row[c])}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function formatCell(val) {
  if (val === null || val === undefined) return <span style={{ color: 'var(--text-muted)' }}>—</span>;
  if (typeof val === 'boolean') return val ? <span className="pill pill-success">yes</span> : <span className="pill pill-muted">no</span>;
  if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}T/)) return new Date(val).toLocaleString();
  if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}$/)) return new Date(val + 'T00:00:00').toLocaleDateString();
  return String(val);
}
